import * as React from "react";
import { styled } from "@mui/system";
import { Switch } from "@mui/material";

const CustomSwitch = styled(Switch)(({ theme, customColor = "gold" }) => ({
  "& .MuiSwitch-switchBase.Mui-checked": {
    color: customColor,
  },
  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
    backgroundColor: customColor,
  },
}));

const label = { inputProps: { "aria-label": "Switch demo" } };

export default function BasicSwitches({ setToggleState, customColor }) {
  const [checked, setChecked] = React.useState(true);

  const handleToggle = (event) => {
    setChecked(event.target.checked);
    setToggleState(event.target.checked);
  };
  return (
    <div>
      <CustomSwitch
        {...label}
        customColor={customColor}
        checked={checked}
        onChange={handleToggle}
        size="large"
      />
    </div>
  );
}
